import React, { useState, useRef, useEffect, useContext, useCallback } from 'react'
// import {  useDispatch } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { actlistData, actmore, setisfirsttime } from "../../actions/index";
import Navigationtitle from "../include/Navigationtitle";
import { IoColorPaletteOutline } from "react-icons/io5";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import DataService from ".././../services/tutorial.service";
import { getDatabase, ref, remove, push, onValue, set, off, update } from "firebase/database";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faL, faShareNodes } from '@fortawesome/free-solid-svg-icons'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { faExpand } from '@fortawesome/free-solid-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { confirmAlert } from "react-confirm-alert";
import { gif1, gif2, gif3, gif4, hexagon } from "../../constants/Images";
import { useSelector, useDispatch } from "react-redux";
import { BsLayoutWtf } from "react-icons/bs";
import { PiSelectionBackgroundFill } from "react-icons/pi";
import { TbListDetails } from "react-icons/tb";
import { MdOutlineSettingsBackupRestore } from "react-icons/md";
// import { color } from 'html2canvas/dist/types/css/types/color';
import { CiImport } from "react-icons/ci";

import { ovtheme1, ovtheme2 } from "../../constants/Images";

export default function AuctionCustomization(match) {
    const dispatch = useDispatch();

    const loginuser = useSelector((state) => state.setUserlog);

    const aucmoredetail = useSelector((state) => state.actmoredata);
    const [aucdetail, setaucdetail] = useState(aucmoredetail);
    const [aucback, setaucback] = useState("");
    const [selectedOption, setSelectedOption] = useState('0');

    const [aucbackbox, setaucbackbox] = useState("");
    const [aucstampbox, setaucstampbox] = useState("");
    const [aucustampbox, setaucustampbox] = useState("");
    const [aucsoldstamp, setaucsoldstamp] = useState("");
    const [aucunsoldstamp, setaucunsoldstamp] = useState("");
    const [aucsponsorbox, setaucsponsorbox] = useState("");
    const [aucbannerbox, setaucbannerbox] = useState("");
    const [aucsponsor, setaucsponsor] = useState("");
    const [aucbanner, setaucbanner] = useState("");
    const [isimgpop, setisimgpop] = useState(false);
    const [imgpopdata, setimgpopdata] = useState([]);
    const [imgpoptype, setimgpoptype] = useState("");
    const [isbgpop, setisbgpop] = useState(false)
    const [bgdata, setbgdata] = useState([])
    const [isfullbg, setisfullbg] = useState(false)
    const [selectedbgfl, setselectedbgfl] = useState("")
    const [bgfulldata, setbgfulldata] = useState('')

    const [isActive, setActive] = useState(false);
    const [cid, setCid] = useState(loginuser["cid"]);
    const [customtype, setcustomtype] = useState('theme')
    const [primarycolor, setprimarycolor] = useState('#0a1c41')
    const [secondarycolor, setsecondarycolor] = useState('#00ffdf')
    const [primaryfontcolor, setprimaryfontcolor] = useState('#002236')
    const [secondaryfontcolor, setsecondaryfontcolor] = useState('#ffffff')
    const [tertiarycolor, settertiarycolor] = useState('#002236')
    const [tertiaryfontcolor, settertiaryfontcolor] = useState('#ffffff')
    const [primarycolor_gc1, setprimarycolor_gc1] = useState('');
    const [primarycolor_gc2, setprimarycolor_gc2] = useState('');

    const [theme, setTheme] = useState(1);
    const [themecheck, setThemecheck] = useState(2);

    const [isInitialLoad, setIsInitialLoad] = useState(true);

    const aid = localStorage.getItem("auction_id");
    const updtoken = useSelector((state) => state.updtoken);

    const history = useHistory({ forceRefresh: true });


    const fileInputRefs = useRef(Array.from({ length: 8 }, () => React.createRef()));

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const defaultset = (forceDefault = false) => {
        console.log('defaultset');
        // Default values for content section
        var themeData = {
        
        };
        
        if(!forceDefault &&aucmoredetail.ov_custom && aucmoredetail.ov_theme==theme){
            console.log('called');
            themeData=aucmoredetail.ov_custom;
        }
        else{
            

            if (theme == 1) {
    
                themeData = {
                    primarycolor: '#0a1c41',
                    secondarycolor: '#00ffdf',
                    tertiarycolor: '#082842',
                    primarycolor_gc1: '',
                    primarycolor_gc2: '',
                    primaryfontcolor: '#002236',
                    secondaryfontcolor: '#ffffff',
                    tertiaryfontcolor: '#ffffff'
                };
            }
            else if (theme == 2) {
                console.log('theme 2');
                themeData = {
                    primarycolor: '',
                    primarycolor_gc1: '#0c1b37',
                    primarycolor_gc2: '#7081ae',
                    secondarycolor: '#55abc8',
                    tertiarycolor: '',
                    primaryfontcolor: '#ffffff',
                    secondaryfontcolor: '#ffffff',
                    tertiaryfontcolor: ''
                };
            }
        }


        // Set the default colors

        setprimarycolor(themeData.primarycolor);
        setsecondarycolor(themeData.secondarycolor);
        setprimaryfontcolor(themeData.primaryfontcolor);
        setsecondaryfontcolor(themeData.secondaryfontcolor);
        setprimarycolor_gc1(themeData.primarycolor_gc1);
        setprimarycolor_gc2(themeData.primarycolor_gc2);
    };
    useEffect(() => {
            defaultset();
        
    }, [theme]);
    useEffect(() => {
        if (aucmoredetail.more) {
            if (aucmoredetail.more[0].bg != "" && aucmoredetail.more[0].bg != null) {
                setaucbackbox(aucmoredetail.fpath + aucmoredetail.more[0].bg)
            }

            if (aucmoredetail.more[0].sstamp != "" && aucmoredetail.more[0].sstamp != null) {
                setaucstampbox(aucmoredetail.fpath + aucmoredetail.more[0].sstamp)
            }
            if (aucmoredetail.more[0].fireworks != "" && aucmoredetail.more[0].fireworks != null) {
                setSelectedOption(aucmoredetail.more[0].fireworks)
            }
            if (aucmoredetail.more[0].usstamp != "" && aucmoredetail.more[0].usstamp != null) {
                setaucustampbox(aucmoredetail.fpath + aucmoredetail.more[0].usstamp)
            }
            // Set initial theme from API data
            if (aucmoredetail.ov_theme) {
                setTheme(parseInt(aucmoredetail.ov_theme))
                setThemecheck(parseInt(aucmoredetail.ov_theme))
            }
            if (aucmoredetail.ov_custom) {
                const thData = aucmoredetail.ov_custom;
                setprimarycolor(thData.primarycolor)
                setsecondarycolor(thData.secondarycolor)
                setprimaryfontcolor(thData.primaryfont)
                setsecondaryfontcolor(thData.secondaryfont)
                setprimarycolor_gc1(thData.primarycolor_gc1)
                setprimarycolor_gc2(thData.primarycolor_gc2)
                setIsInitialLoad(false);
            }
        }
    }, [aucmoredetail])

    useEffect(() => {
        window.scrollTo(0, 0);
        const isFirstMount = localStorage.getItem('isFirstMount');
        //  console.log('isFirstMount')
        //  console.log(isFirstMount)
        if (!isFirstMount) {
            //  console.log('setting false')
            localStorage.setItem('isFirstMount', false);
        } else {
            //  console.log('going back....')

            localStorage.removeItem('isFirstMount');
            // history.push('/auction-detail');
        }
    }, [history]);

    const handleFileChange = (e, t) => {
        const file = e.target.files[0];
        if (t == "1") {
            setaucback(file)
        }
        else if (t == "2") {
            setaucsoldstamp(file)
        }
        else if (t == "3") {
            setaucunsoldstamp(file)
        }
        else if (t == "4") {
            setaucsponsor(file)
        }
        else if (t == "5") {
            setaucbanner(file)
        }
        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                if (t == "1") {
                    setaucbackbox(event.target.result);
                }
                else if (t == "2") {
                    setaucstampbox(event.target.result)
                }
                else if (t == "3") {
                    setaucustampbox(event.target.result)
                }
                else if (t == "4") {
                    setaucsponsorbox(event.target.result)
                }
                else if (t == "5") {
                    setaucbannerbox(event.target.result)
                }
            };
            reader.readAsDataURL(file);
        }
    };

    const removefile = async (imgpoptype) => {
        if (imgpoptype == '3' || imgpoptype == '4' || imgpoptype == '5') {
            setActive(true);
            const id = toast.loading("Please wait...");

            let toastContainerId = toast.update(id, {
                render: "please wait...",
                theme: "dark",
                position: "bottom-center",
            });
            var hdr = {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
                },
            };
            var vals = {}

            if (imgpoptype == '3') {
                vals.fltyp = 'bg';
            }
            else if (imgpoptype == '4') {
                vals.fltyp = 'sstamp';
            }
            else if (imgpoptype == '5') {
                vals.fltyp = 'usstamp';
            }
            await DataService.delfiles(vals, hdr)
                .then((res) => {
                    let response = res.data;
                    toast.dismiss(toastContainerId);

                    if (response.success == true) {
                        setisimgpop(false)
                        if (imgpoptype == '3') {
                            setaucdetail(detail => ({
                                ...detail,
                                more: [{ ...detail.more[0], bg: "" }]
                            }))
                        }
                        else if (imgpoptype == '4') {
                            setaucdetail(detail => ({
                                ...detail,
                                more: [{ ...detail.more[0], sstamp: "" }]
                            }))
                        }
                        else if (imgpoptype == '5') {
                            setaucdetail(detail => ({
                                ...detail,
                                more: [{ ...detail.more[0], usstamp: "" }]
                            }))
                        }
                        toast.success("Removed !!", {
                            theme: "colored",
                            position: "bottom-center",
                        });

                    } else {
                        if (response.msg != "")
                            toast.error(response.msg, { theme: "colored" });
                    }

                    setActive(false);
                })
                .catch(() => {
                    //  console.log("Not valid");
                    toast.error("Not valid Server Error", { theme: "colored" });
                    setActive(false);
                });
        }
        else if (imgpoptype == '2') {
            setActive(true);
            const id = toast.loading("Please wait...");

            let toastContainerId = toast.update(id, {
                render: "please wait...",
                theme: "dark",
                position: "bottom-center",
            });
            var hdr = {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
                },
            };
            var vals = {}
            vals.i = imgpopdata.spnid

            await DataService.delspn(vals, hdr)
                .then((res) => {
                    let response = res.data;
                    toast.dismiss(toastContainerId);
                    if (response.success == true) {
                        const db = getDatabase();
                        set(ref(db, 'auction/info/' + aid), {
                            "type": "1", "upd": "6", 'id': aid, "detail": {
                                "typ": 14,
                                "upd": 2,
                                "val": imgpopdata.spnid,
                            }, "tkn": updtoken
                        });
                        setisimgpop(false)
                        setaucdetail(detail => ({
                            ...detail,
                            spn: detail.spn.filter((sp) => sp.spnid != imgpopdata.spnid)
                        }))
                        toast.success("Removed !!", {
                            theme: "colored",
                            position: "bottom-center",
                        });

                    } else {
                        if (response.msg != "")
                            toast.error(response.msg, { theme: "colored" });
                    }

                    setActive(false);
                })
                .catch(() => {
                    //  console.log("Not valid");
                    toast.error("Not valid Server Error", { theme: "colored" });
                    setActive(false);
                });
        }
        else if (imgpoptype == '1') {
            setActive(true);
            const id = toast.loading("Please wait...");

            let toastContainerId = toast.update(id, {
                render: "please wait...",
                theme: "dark",
                position: "bottom-center",
            });
            var hdr = {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
                },
            };
            var vals = {}
            vals.i = imgpopdata.bnrid

            await DataService.delbnr(vals, hdr)
                .then((res) => {
                    let response = res.data;
                    toast.dismiss(toastContainerId);
                    if (response.success == true) {
                        const db = getDatabase()
                        set(ref(db, 'auction/info/' + aid), {
                            "type": "1", "upd": "6", 'id': aid, "detail": {
                                "typ": 15,
                                "upd": 2,
                                "val": { id: imgpopdata.bnrid },
                            }, "tkn": updtoken
                        });
                        setisimgpop(false)
                        setaucdetail(detail => ({
                            ...detail,
                            bnr: detail.bnr.filter((bn) => bn.bnrid != imgpopdata.bnrid)
                        }))
                        toast.success("Removed !!", {
                            theme: "colored",
                            position: "bottom-center",
                        });

                    } else {
                        if (response.msg != "")
                            toast.error(response.msg, { theme: "colored" });
                    }

                    setActive(false);
                })
                .catch(() => {
                    //  console.log("Not valid");
                    toast.error("Not valid Server Error", { theme: "colored" });
                    setActive(false);
                });
        }
    }

    const removeuploads = async (t) => {
        setActive(true);
        const id = toast.loading("Please wait...");

        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });
        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        var vals = {}
        if (t == '1') {
            vals.fltyp = 'bg';
        }
        else if (t == '2') {
            vals.fltyp = 'sstamp';
        }
        else if (t == '3') {
            vals.fltyp = 'usstamp';
        }
        await DataService.delfiles(vals, hdr)
            .then((res) => {
                let response = res.data;
                toast.dismiss(toastContainerId);

                if (response.success == true) {
                    setisimgpop(false)
                    if (t == '1') {
                        setaucbackbox("")
                        setaucdetail(detail => ({
                            ...detail,
                            more: [{ ...detail.more[0], bg: "" }]
                        }))
                        const db = getDatabase();
                        set(ref(db, 'auction/info/' + aid), {
                            "type": "1", "upd": "6", 'id': aid, "detail": {
                                "typ": 13,
                                "upd": 2,
                                "val": "",
                            }, "tkn": updtoken
                        });
                    }
                    else if (t == '2') {
                        setaucstampbox("")
                        setaucdetail(detail => ({
                            ...detail,
                            more: [{ ...detail.more[0], sstamp: "" }]
                        }))
                    }
                    else if (t == '3') {
                        setaucustampbox("")
                        setaucdetail(detail => ({
                            ...detail,
                            more: [{ ...detail.more[0], usstamp: "" }]
                        }))
                    }
                    toast.success("Removed !!", {
                        theme: "colored",
                        position: "bottom-center",
                    });

                } else {
                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
    }
    const delfile = (t) => {
        confirmAlert({
            message: "Are you sure delete this record !",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => removeuploads(t),
                },
                {
                    label: "No",
                    // onClick: () => del(id, 0),
                },
            ],
        });
    };
    const themesubmit = async () => {
        setActive(true);
        const id = toast.loading("Please wait...");

        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });
        //  console.log('aid')
        //  console.log(aid)
        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        var vals = { bs: '1', ms: '2' }
        // vals.bg = themebg.substring(themebg.lastIndexOf('/') + 1)
        vals.theme = theme
        vals.custom = {
            primarycolor: primarycolor,
            secondarycolor: secondarycolor,
            primarycolor_gc1: primarycolor_gc1,
            primarycolor_gc2: primarycolor_gc2,
            primaryfont: primaryfontcolor,
            secondaryfont: secondaryfontcolor,
            tertiarycolor: tertiarycolor,
            tertiaryfont: tertiaryfontcolor

        }

        // vals.custom = {
        //     colors: {
        //         title_c: color,
        //         bid_c: color2,
        //         pl_name_dt_c: color3,
        //         border_c: color4,
        //         team_C: color5,
        //         pl_head_gc1: color6,
        //         pl_head_gc2: color7,
        //         pl_border_c: color8,
        //         pl_shadow_c: color9,
        //         pl_detail_bg_gc1: color10,
        //         pl_detail_bg_gc2: color11,
        //         pl_dt_shadow_c: color12,
        //         extra_dt_c: color13,
        //         mp_label_c: color14,
        //         mp_val_c: color15,
        //         pl_border_gc1: color16,
        //         pl_border_gc2: color17,
        //         mp_bg_gc1: color18,
        //         mp_bg_gc2: color19

        //     },


        await DataService.setovtheme(vals, hdr)
            .then((res) => {
                let response = res.data;
                console.log('theme submit response')
                console.log(response)
                //  console.log(vals)
                toast.dismiss(toastContainerId);
                if (response.success == true) {

                    // var auccopy = aucdetail
                    // auccopy.more[0].theme = theme
                    // auccopy.more[0].bg = themebg
                    // auccopy.custom = vals.custom
                    // dispatch(actmore(auccopy));


                    toast.success("Effect set !!", {
                        theme: "colored",
                        position: "bottom-center",
                    });
                    // setaucbackbox(bgdata.path + selectedbgfl)
                } else {
                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
    }
    const del = useCallback(
        async (vl, status) => {
            if (status == 1) {
                setActive(true);

                var hdr = {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Authorization: JSON.stringify([{ cid: loginuser["cid"], token: loginuser["token"] }]),
                    },
                };

                await DataService.deleteAuction({ aid: encode(vl) }, hdr)
                    .then((res) => {
                        let response = res.data;
                        if (response.success == true) {
                            toast.success(response.msg, {
                                theme: "dark",
                                position: "bottom-center",
                            });

                            const updateitem = getpageData.responsedata.list.filter(
                                (ele, ind) => {
                                    if (ele.aid != vl) {
                                        return ele;
                                    }
                                }
                            );
                            let responsedata = {
                                responsedata: {
                                    path: getpageData.responsedata.path,
                                    cid: cid,
                                    list: updateitem,
                                },
                            };
                            dispatch(actlistData(responsedata));
                            history.push(BASE_PATH + "my-auction");
                            // const updateitem = data.list.filter((ele, ind) => {
                            //   return ele.aid != vl;
                            // });
                            // data.list = updateitem;
                            // setData(data);
                        } else {
                            toast.error(response.msg, {
                                theme: "colored",
                                position: "bottom-center",
                            });
                        }

                        setActive(false);
                    })
                    .catch(() => {
                        //  console.log("Not valid");
                        toast.error("Not valid Server Error", {
                            theme: "colored",
                            position: "bottom-center",
                        });
                        setActive(false);
                    });
            }
        },
        []
    );
    function showfullbg(ele) {
        setisfullbg(true)
        setbgfulldata(ele)
    }
    function handleDivClick(fl) {
        setselectedbgfl(fl)
    }
    const setfireworkeffect = async () => {
        setActive(true);
        const id = toast.loading("Please wait...");

        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });
        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        var vals = {}
        // vals.fltyp = 'bg';
        vals.fireworks = selectedOption
        await DataService.setfirework(vals, hdr)
            .then((res) => {
                let response = res.data;
                //  console.log('firework response')
                //  console.log(response)
                //  console.log(vals)
                toast.dismiss(toastContainerId);
                if (response.success == true) {
                    setaucdetail(detail => ({
                        ...detail,
                        more: [{ ...detail.more[0], fireworks: selectedOption }]
                    }))

                    var auccopy = aucdetail
                    auccopy.more[0].fireworks = selectedOption
                    dispatch(actmore(auccopy));
                    // const db = getDatabase();
                    // set(ref(db, 'auction/info/' + aid), {
                    //   "type": "1", "upd": "6", 'id': aid, "detail": {
                    //     "typ": 13,
                    //     "upd": 1,
                    //     "val": { img: response.data.newentry.logo },
                    //   }, "tkn": updtoken
                    // });
                    // setisbgpop(false)
                    // setselectedbgfl("")

                    toast.success("Effect set !!", {
                        theme: "colored",
                        position: "bottom-center",
                    });
                    // setaucbackbox(bgdata.path + selectedbgfl)
                } else {
                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });

    }
    const setbg = async () => {
        setActive(true);
        const id = toast.loading("Please wait...");

        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });
        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        var vals = {}
        vals.fltyp = 'bg';
        vals.fl = selectedbgfl
        await DataService.setbg(vals, hdr)
            .then((res) => {
                let response = res.data;
                toast.dismiss(toastContainerId);
                if (response.success == true) {
                    const db = getDatabase();
                    set(ref(db, 'auction/info/' + aid), {
                        "type": "1", "upd": "6", 'id': aid, "detail": {
                            "typ": 13,
                            "upd": 1,
                            "val": { img: response.data.newentry.logo },
                        }, "tkn": updtoken
                    });
                    setisbgpop(false)
                    setselectedbgfl("")

                    toast.success("Background set !!", {
                        theme: "colored",
                        position: "bottom-center",
                    });
                    setaucbackbox(bgdata.path + selectedbgfl)
                } else {
                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });

    }
    const banneradd = async () => {
        setActive(true);
        const id = toast.loading("Please wait...");
        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });

        var hdr = {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        const formData = new FormData();
        formData.append("bnrimg", aucbanner);

        await DataService.addbanner(formData, hdr)
            .then((res) => {
                let response = res.data;
                toast.dismiss(toastContainerId);
                // //  console.log(response)
                if (response.success == true) {
                    const db = getDatabase()
                    set(ref(db, 'auction/info/' + aid), {
                        "type": "1", "upd": "6", 'id': aid, "detail": {
                            "typ": 15,
                            "upd": 1,
                            "val": response.data.newentry,
                        }, "tkn": updtoken
                    });
                    setaucbannerbox("")
                    fileInputRefs.current.forEach((ref) => {
                        if (ref.current) {
                            ref.current.value = '';
                        }
                    });
                    setaucdetail(prev => ({
                        ...prev,
                        bnr: [...prev.bnr, response.data.newentry]
                    }))
                    // //  console.log("setted")
                    toast.success("Banner Added !!", {
                        theme: "colored",
                        position: "bottom-center",
                    });

                    setaucbanner("")
                } else {
                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
    }
    const handleImportClick = () => {
        document.getElementById('fileInputt').click();
    };
    const sponsoradd = async () => {
        setActive(true);
        const id = toast.loading("Please wait...");
        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });

        var hdr = {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        const formData = new FormData();
        formData.append("splogo", aucsponsor);
        await DataService.addsponsor(formData, hdr)
            .then((res) => {
                let response = res.data;
                toast.dismiss(toastContainerId);
                // //  console.log(response)
                if (response.success == true) {
                    //  console.log('sponsor add response....!!')
                    //  console.log(response.success)
                    const db = getDatabase();
                    //  console.log('sponsor add response ddd....!!')

                    set(ref(db, 'auction/info/' + aid), {
                        "type": "1", "upd": "6", 'id': aid, "detail": {
                            "typ": 14,
                            "upd": 1,
                            "val": response.data.newentry,
                        }, "tkn": updtoken
                    });
                    // //  console.log("setted")
                    //  console.log('sponsor add response eee....!!')

                    setaucsponsorbox("")
                    fileInputRefs.current.forEach((ref) => {
                        if (ref.current) {
                            ref.current.value = '';
                        }
                    });
                    toast.success("Sponsor Added !!", {
                        theme: "colored",
                        position: "bottom-center",
                    });
                    //  console.log('sponsor add response 22222....!!')

                    setaucdetail(prev => ({
                        ...prev,
                        spn: [...prev.spn, response.data.newentry]
                    }))

                    setaucsponsor("")
                } else {
                    //  console.log('sponsor add response 33333....!!')

                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }
                //  console.log('sponsor add response. 444...!!')

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
    }
    const chooseback = async () => {
        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
            },
        };

        await DataService.bglist({}, hdr)
            .then((res) => {
                let response = res.data;
                if (response.success == true) {
                    setbgdata(response.data)

                } else {
                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
        setisbgpop(!isbgpop)

    }
    const uploadfiles = async (typ) => {
        setActive(true);
        const id = toast.loading("Please wait...");
        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });

        var hdr = {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        const formData = new FormData();
        if (typ == 'bg') {
            // if (aucbackbox == "") {

            //   formData.append("fl", aucback);
            // } else {
            //   alert('This background is already set !!')
            //   toast.dismiss(toastContainerId); // Dismiss the toast message here

            //   return 0
            // }
            formData.append("fl", aucback);

            const fileSizeKB = Math.round(aucback.size / 1024); // Convert bytes to kilobytes
            const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
            if (fileSizeMB > 1.25) {
                alert('File size must be less than 1.25Mb')
                toast.dismiss(toastContainerId);
                return 0
            }

        }
        else if (typ == 'sstamp') {
            formData.append("fl", aucsoldstamp);
            const fileSizeKB = Math.round(aucsoldstamp.size / 1024); // Convert bytes to kilobytes
            const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
            if (fileSizeMB > 1.25) {
                alert('File size must be less than 1.25Mb')
                toast.dismiss(toastContainerId);
                return 0
            }


        }
        else if (typ == 'usstamp') {
            formData.append("fl", aucunsoldstamp);
            const fileSizeKB = Math.round(aucunsoldstamp.size / 1024); // Convert bytes to kilobytes
            const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
            if (fileSizeMB > 1.25) {
                alert('File size must be less than 1.25Mb')
                toast.dismiss(toastContainerId);
                return 0
            }




        }

        formData.append("fltyp", typ);
        await DataService.addfiles(formData, hdr)
            .then((res) => {
                let response = res.data;
                toast.dismiss(toastContainerId);
                if (response.success == true) {
                    if (typ == 'bg') {
                        setaucdetail(detail => ({
                            ...detail,
                            more: [{ ...detail.more[0], bg: response.data.newentry.logo }]
                        }))
                        setaucback("")
                        const db = getDatabase();
                        set(ref(db, 'auction/info/' + aid), {
                            "type": "1", "upd": "6", 'id': aid, "detail": {
                                "typ": 13,
                                "upd": 1,
                                "val": { img: response.data.newentry.logo },
                            }, "tkn": updtoken
                        });

                    }
                    else if (typ == 'sstamp') {

                        setaucdetail(detail => ({
                            ...detail,
                            more: [{ ...detail.more[0], sstamp: response.data.newentry.logo }]
                        }))
                        setaucsoldstamp("")
                    }
                    else if (typ == 'usstamp') {
                        setaucdetail(detail => ({
                            ...detail,
                            more: [{ ...detail.more[0], usstamp: response.data.newentry.logo }]
                        }))
                        setaucunsoldstamp("")
                    }
                    // //  console.log("setted")
                    fileInputRefs.current.forEach((ref) => {
                        if (ref.current) {
                            ref.current.value = '';
                        }
                    });
                    toast.success("Added !!", {
                        theme: "colored",
                        position: "bottom-center",
                    });

                    // setaucdetail(prev => ({
                    //   ...prev,
                    //   spn: [...prev.spn, response.data.newentry]
                    // }))

                } else {
                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
    }
    function setimagepopup(item, t) {
        setisimgpop(true)
        setimgpopdata(item)
        setimgpoptype(t)
    }
    const [mythemes] = useState([
        {
            no: 1,
            img: ovtheme1
        },
        {
            no: 2,
            img: ovtheme2
        },

        // Add more themes here as needed
    ]);
    const askdefaultset = (id) => {
        confirmAlert({
            message: "Are you want to download changes ?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => { downloadcustomchanges(); defaultset(true) },
                },
                {
                    label: "No",
                    onClick: () => defaultset(true),
                },
            ],
        });
    };

    const handleDivClick2 = (themeNo) => {
        setTheme(themeNo);
        // Add any additional theme change logic here
    };

    const downloadcustomchanges = () => {
        // Create theme JSON object with current values
        const themeJSON = {
            primarycolor: primarycolor,
            primarycolor_gc1: primarycolor_gc1,
            primarycolor_gc2: primarycolor_gc2,
            secondarycolor: secondarycolor,
            primaryfontcolor: primaryfontcolor,
            secondaryfontcolor: secondaryfontcolor,
            theme: theme
        }

        // Convert the object to a JSON string
        const dataStr = JSON.stringify(themeJSON, null, 2);

        // Create a Blob with the data
        const blob = new Blob([dataStr], { type: "application/json" });

        // Create a link element
        const link = document.createElement("a");

        // Create a download URL from the Blob
        const url = URL.createObjectURL(blob);

        // Set the download link attributes
        link.href = url;
        link.download = "overlay_theme.json"; // The name of the file to be saved

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by revoking the object URL after the download
        URL.revokeObjectURL(url);
    }

    // Add a function to handle importing saved theme
    const handleThemeImport = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const json = JSON.parse(e.target.result);
                    // Set all theme parameters
                    setprimarycolor(json.primarycolor || '#0a1c41');
                    setprimarycolor_gc1(json.primarycolor_gc1 || '');
                    setprimarycolor_gc2(json.primarycolor_gc2 || '');
                    setsecondarycolor(json.secondarycolor || '#00ffdf');
                    setprimaryfontcolor(json.primaryfontcolor || '#002236');
                    setsecondaryfontcolor(json.secondaryfontcolor || '#ffffff');
                    settertiarycolor(json.tertiarycolor || '#082842');
                    settertiaryfontcolor(json.tertiaryfontcolor || '#ffffff');
                    setTheme(json.theme || 1);
                    
                    toast.success("Theme imported successfully!", { theme: "colored" });
                } catch (error) {
                    console.error('Error parsing JSON:', error);
                    toast.error("Invalid theme file", { theme: "colored" });
                }
            };
            reader.readAsText(file);
            // Reset the file input
            event.target.value = '';
        }
    };

    return (
        <div>
            <Navigationtitle data={match} />
            <div className="custom_auction_theme custom_overlay">
                <div className='custom_options'>
                    <div className={`custom_options_child ${customtype == 'theme' && 'active_blue'}`} onClick={() => setcustomtype('theme')}>

                        <div>
                            <BsLayoutWtf />
                        </div>
                        <div>
                            <label htmlFor="">Theme</label>
                        </div>

                    </div>
                    <div className={`custom_options_child ${customtype == 'data' && 'active_blue'}`} onClick={() => setcustomtype('data')}>

                        <div>
                            <TbListDetails />
                        </div>
                        <div>
                            <label htmlFor="">Content</label>
                        </div>
                    </div>
                    <div className={`custom_options_child`}
                        onClick={() => askdefaultset()}
                    >

                        <div>
                            <MdOutlineSettingsBackupRestore />
                        </div>
                        <div>
                            <label htmlFor="">Default</label>
                        </div>
                    </div>
                    <div className={`custom_options_child`} onClick={handleImportClick}>

                        <div>
                            <CiImport />
                        </div>
                        <div>
                            <label htmlFor="">Import</label>
                        </div>

                        <input
                            type="file"
                            id="fileInputt"
                            style={{ display: 'none' }}
                            accept=".json"
                            onChange={handleThemeImport}
                        />
                    </div>


                </div>
                <div className='Custom_available_options'>
                    {customtype == 'theme' &&
                        <>
                            <div className='backgrounds_container'>
                                <div className="custom_head">Choose Theme</div>
                                <div>
                                    {mythemes.map((ele, index) => {
                                        return (
                                            <div
                                                key={index}
                                                className={`custom_option_image ${theme === ele.no ? 'selected' : ''}`}
                                                onClick={() => handleDivClick2(ele.no)}
                                                style={theme === ele.no ? {
                                                    border: `2px solid ${secondarycolor}`,
                                                    boxShadow: `0 0 10px ${secondarycolor}`
                                                } : {}}
                                            >
                                                <img src={ele.img} alt="" />
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </>
                    }
                    {customtype == 'data' &&
                        <>
                            <div className='custom_color_options'>
                                <div className='col_label'>
                                    {/* <IoColorPaletteOutline className='col_icon' /> */}
                                    <label htmlFor="">Choose color</label>

                                </div>
                                {/* <input type="color" className='color_inp rounded-color-input' value={primarycolor} onChange={(e) => setprimarycolor(e.target.value)} /> */}
                            </div>
                            {theme == 1 && <div className='custom_color_options'>
                                <div className='col_label'>
                                    <IoColorPaletteOutline className='col_icon' />
                                    <label htmlFor="">Primary color</label>
                                </div>
                                <input type="color" className='color_inp rounded-color-input' value={primarycolor} onChange={(e) => setprimarycolor(e.target.value)} />
                            </div>}
                            {theme == 2 && <div className='custom_color_options'>
                                <div className='col_label'>
                                    <IoColorPaletteOutline className='col_icon' />
                                    <label htmlFor="">Primary color</label>
                                </div>
                                <input type="color" className='color_inp rounded-color-input' value={primarycolor_gc1} onChange={(e) => setprimarycolor_gc1(e.target.value)} />
                                <input type="color" className='color_inp rounded-color-input' value={primarycolor_gc2} onChange={(e) => setprimarycolor_gc2(e.target.value)} />
                            </div>}
                            <div className='custom_color_options'>
                                <div className='col_label'>
                                    <IoColorPaletteOutline className='col_icon' />
                                    <label htmlFor="">Secondary color</label>
                                </div>
                                <input type="color" className='color_inp rounded-color-input' value={secondarycolor} onChange={(e) => setsecondarycolor(e.target.value)} />
                            </div>
                            {theme == 1 && <div className='custom_color_options'>
                                <div className='col_label'>
                                    <IoColorPaletteOutline className='col_icon' />
                                    <label htmlFor="">Tertiary color</label>
                                </div>
                                <input type="color" className='color_inp rounded-color-input' value={tertiarycolor} onChange={(e) => settertiarycolor(e.target.value)} />
                            </div>}
                            <div className='custom_color_options'>
                                <div className='col_label'>
                                    {/* <IoColorPaletteOutline className='col_icon' /> */}
                                    <label htmlFor="">Choose Font color</label>

                                </div>
                                {/* <input type="color" className='color_inp rounded-color-input' value={primarycolor} onChange={(e) => setprimarycolor(e.target.value)} /> */}
                            </div>
                            <div className='custom_color_options'>
                                <div className='col_label'>
                                    <IoColorPaletteOutline className='col_icon' />
                                    <label htmlFor="">Primary color</label>
                                </div>
                                <input type="color" className='color_inp rounded-color-input' value={primaryfontcolor} onChange={(e) => setprimaryfontcolor(e.target.value)} />
                            </div>
                            {theme == 1 && <div className='custom_color_options'>
                                <div className='col_label'>
                                    <IoColorPaletteOutline className='col_icon' />
                                    <label htmlFor="">Secondary color</label>
                                </div>
                                <input type="color" className='color_inp rounded-color-input' value={secondaryfontcolor} onChange={(e) => setsecondaryfontcolor(e.target.value)} />
                            </div>}
                            {theme == 1 && <div className='custom_color_options'>
                                <div className='col_label'>
                                    <IoColorPaletteOutline className='col_icon' />
                                    <label htmlFor="">Tertiary color</label>
                                </div>
                                <input type="color" className='color_inp rounded-color-input' value={tertiaryfontcolor} onChange={(e) => settertiaryfontcolor(e.target.value)} />
                            </div>}
                        </>
                    }

                </div>
                <div className='custom_preview' >
                    {theme == 1 &&
                        <>
                            <div class="box1 fb_profile">
                                <div class="tp" style={{ "--secondary-color": secondarycolor }}></div>
                                <div class="btm" style={{ "--secondary-color": secondarycolor }}></div>
                                <div id="playername" class="fnt1 fs1 l2" style={{ background: secondarycolor, border: `1px solid ${secondarycolor}`, boxShadow: `inset 0 0 5px ${secondarycolor}`, color: primaryfontcolor }}>Sonu bajaj</div>
                                <div id="tempdetail" style={{ background: primarycolor, color: secondarycolor }} class="tempdetail">
                                    <div class="agediv" ><h4 style={{ color: secondaryfontcolor }}>All-rounder Batsman</h4></div><div class="agediv"><h4 style={{ color: secondaryfontcolor }}>Right Armed Player</h4></div></div>
                                <div id="playerbase" style={{ color: tertiaryfontcolor, background: tertiarycolor }}><div class="lbl" style={{ color: tertiaryfontcolor }}>BASE VALUE</div><div class="val"> 180<span class="pointtyp"> lakh</span></div><div style={{ clear: 'both' }}></div></div>
                                <div id="playerinfo"></div>
                                {/* <div id="soldto" ><div class="lbl">SOLD TO</div><div class="val"></div><div style={{clear:'both'}}></div></div>
                        <div id="unsolddiv" >UNSOLD</div> */}
                            </div>
                            <div class="imgbox plr fb_profile jpg" style={{ background: `url(${hexagon}) no-repeat`, backgroundSize: '100%', backgroundPosition: 'bottom' }}>
                                {/* <div id="pic" style="display:none">
                            <img src=""/>
                        </div> */}
                                <div id="bidtm">
                                    <img src="" />
                                </div>
                            </div>
                            <div class="box2 fb_profile" >
                                <div class="tp"></div>
                                <div class="btm"></div>
                                <div class="bidpoint" style={{ background: secondarycolor, color: primaryfontcolor, border: `1px solid ${secondarycolor}`, boxShadow: `inset 0 0 5px ${secondarycolor}` }}>
                                    <div class="lbl">CURRENT BID</div>
                                    <div class="val fs0" >213.0<span class="pointtyp"> lakh</span></div>
                                </div>
                            </div>
                            <div class="box4 fb_summery">
                                <div class="blp2">

                                </div>
                                <div class="tp"></div>
                                <div class="btm"></div>
                                <div style={{ background: primarycolor }}>
                                    <div class="summerydetail hedclr" style={{ background: primarycolor, border: `1px solid ${secondarycolor}`, boxShadow: `inset 0 0 5px ${secondarycolor}`, color: secondaryfontcolor }} >
                                        <div class="summeryteam fs2">Team</div>
                                        <div class="smplayer fs2">PL</div>
                                        <div class="smtotal fs2">Points</div>
                                        <div style={{ clear: 'both' }}></div>
                                    </div>
                                    <div class="summerybox tm_grp_all tm_grp_0" style={{ border: `1px solid ${secondarycolor}` }} >
                                        <div class="summerydetail oddclr rowclr" style={{ border: `1px solid ${secondarycolor}`, color: secondaryfontcolor }}>
                                            <div class="summeryteam fs2">BENGAL WARRIORS&nbsp;</div>
                                            <div class="smplayer fs2" id="tplayercnt_84360">1</div>
                                            <div class="smtotal fs2" id="totalcnt_84360">17820.0<span class="pointtyp"> lakh</span></div>
                                            <div style={{ clear: 'both' }}></div>
                                        </div>
                                    </div>
                                    <div class="summerybox tm_grp_all tm_grp_0" style={{ border: `1px solid ${secondarycolor}` }}>
                                        <div class="summerydetail evnclr rowclr" style={{ border: `1px solid ${secondarycolor}`, color: secondaryfontcolor }}>
                                            <div class="summeryteam fs2">CHENNAI SUPER KINGS&nbsp;</div>
                                            <div class="smplayer fs2" id="tplayercnt_75054">1</div>
                                            <div class="smtotal fs2" id="totalcnt_75054">16820.0<span class="pointtyp"> lakh</span></div>
                                            <div style={{ clear: 'both' }}></div>
                                        </div>
                                    </div>
                                    <div class="summerybox tm_grp_all tm_grp_0" style={{ border: `1px solid ${secondarycolor}` }}>
                                        <div class="summerydetail oddclr rowclr" style={{ border: `1px solid ${secondarycolor}`, color: secondaryfontcolor }}>
                                            <div class="summeryteam fs2">GUJRAT TITANS&nbsp;</div>
                                            <div class="smplayer fs2" id="tplayercnt_84362">1</div>
                                            <div class="smtotal fs2" id="totalcnt_84362">26820.0<span class="pointtyp"> lakh</span></div>
                                            <div style={{ clear: 'both' }}></div>
                                        </div>
                                    </div>

                                    {/* <div class="summerybox tm_grp_all tm_grp_2" style="text-align: center; padding: 18px 20px; display: none;">
                                <img src="/manage/images/background/superplwhite.png" style="width: 140px"></div>
                            </div> */}
                                </div>
                            </div>
                            {/* <button onClick={themesubmit}>themesubmit</button> */}
                        </>

                    }
                    {/* ///////////////// theme2 /////////////////////// */}
                    {
                        theme == 2 &&
                        <>
                            <div class="overlay-1">
                                <div class="content-1" >
                                    <div class="top-relative">
                                        <div class="bbid">
                                            <div class="base-bid-outer" style={{ background: secondarycolor }}>
                                            </div>
                                            <div class="base-bid" style={{ color: primaryfontcolor, background: secondarycolor, "--gradient-color-1": primarycolor_gc1, "--gradient-color-2": primarycolor_gc2 }}>
                                                <div class="base-label" style={{ borderBottom: `1px solid ${secondarycolor}` }}>Base Price</div>
                                                <div class="base-value">100000</div>
                                            </div>
                                        </div>

                                        <div class="player" >
                                            <div class="player-image" style={{ border: `3px double ${secondarycolor}` }} >
                                                <img src="https://t3.ftcdn.net/jpg/02/43/12/34/360_F_243123463_zTooub557xEWABDLk0jJklDyLSGl2jrr.jpg"
                                                    alt="" />
                                            </div>
                                            <div class="player-name" style={{
                                                color: primaryfontcolor,
                                                background: secondarycolor,
                                                "--gradient-color-1": primarycolor_gc1,
                                                "--gradient-color-2": primarycolor_gc2
                                            }}>
                                                Virat
                                            </div>
                                            <div class="player-name-outer" style={{ background: secondarycolor }}>
                                            </div>
                                        </div>
                                        <div class="currentbid" >
                                            <div id="currentteam" class="currentteam">Rajasthan Royals</div>
                                            <div class="current-bid-outer" style={{ background: secondarycolor }}>
                                            </div>
                                            <div class="current-bid" style={{ color: primaryfontcolor, background: secondarycolor, "--gradient-color-1": primarycolor_gc1, "--gradient-color-2": primarycolor_gc2 }}>
                                                <div class="current-bid-label" style={{ borderBottom: `1px solid ${secondarycolor}` }}>Current Bid</div>
                                                <div class="current-bid-value">500</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="player-bottom">
                                        <div class="player-detail" style={{ color: primaryfontcolor, background: secondarycolor, "--gradient-color-1": primarycolor_gc1, "--gradient-color-2": primarycolor_gc2 }}>
                                            <div class="spec" style={{ borderRight: `1px solid ${secondarycolor}` }}>RH Bat</div>
                                            <div class="spec2" style={{ borderRight: `1px solid ${secondarycolor}` }}>City Jodhpur</div>
                                            <div class="age">Age 23</div>
                                        </div>
                                    </div>


                                    <div class="hamm">
                                        <img class="hammer" src="images/hammer.png" alt="" />
                                    </div>
                                    <div class="sold-d">
                                        <div class="sold-detail">
                                            <div><img src="images/soldteam.png" alt="" /></div>
                                            <div class="sold-to">
                                                <span class="sold-p-name"> John Doe</span>
                                                <span class="sold-t-name"> Sold to KKR</span>
                                            </div>
                                            <div class="sold-point">23.75 Cr</div>
                                        </div>
                                        <div class="sold-detail-outer">
                                        </div>
                                    </div>
                                    <div class="unsold-d">
                                        <div class="unsold-detail">
                                            <div class="unsold-to">
                                                <span class="unsold-p-name"> John Doe</span>
                                            </div>
                                            <div class="unsold-label"><img src="images/UNSOLDstamp.png" alt="" /></div>
                                        </div>
                                        <div class="unsold-detail-outer">
                                        </div>
                                    </div>
                                </div>
                                <div class="content-2">
                                    <div class="header-main">

                                        <div class="header" style={{ color: primaryfontcolor, "--gradient-color-1": primarycolor_gc1, "--gradient-color-2": primarycolor_gc2, background: secondarycolor }}>
                                            <div>Teams</div>
                                            <div>Points Rem</div>
                                            <div>Player</div>
                                        </div>
                                        <div class="header-outer" style={{ background: secondarycolor }}></div>
                                    </div>
                                    <div class="header-items" >

                                        <div class="item1" style={{ color: primaryfontcolor, "--gradient-color-1": primarycolor_gc1, "--gradient-color-2": primarycolor_gc2, border: `1px solid ${secondarycolor}` }}>
                                            <div>CSK</div>
                                            <div class="t-point" style={{ background: secondarycolor }}>20000</div>
                                            <div class="t-player">2</div>
                                        </div>
                                        <div class="item2" style={{ color: primaryfontcolor, "--gradient-color-1": primarycolor_gc1, "--gradient-color-2": primarycolor_gc2, border: `1px solid ${secondarycolor}` }}>
                                            <div>KKR</div>
                                            <div class="t-point" style={{ background: secondarycolor }}>30000</div>
                                            <div class="t-player">3</div>
                                        </div>
                                        <div class="item3" style={{ color: primaryfontcolor, "--gradient-color-1": primarycolor_gc1, "--gradient-color-2": primarycolor_gc2, border: `1px solid ${secondarycolor}` }}>
                                            <div>RR</div>
                                            <div class="t-point" style={{ background: secondarycolor }}>50000</div>
                                            <div class="t-player">6</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                </div>
            </div>

            {/* Add buttons container below */}
            <div className="action-buttons">

                <button
                    className="download-btn"
                    onClick={downloadcustomchanges}
                >
                    Download Theme
                </button>
                <button
                    className="apply-btn"
                    onClick={themesubmit}
                >
                    Apply Changes
                </button>
            </div>
        </div>
    )
}
